

import { Component, Mixins, Prop } from 'vue-property-decorator';
import Chart from 'chart.js';
import { Line } from 'vue-chartjs';

@Component
export default class LineBar4 extends Mixins(Line) {
  @Prop({ required: true })
  private chartLabels!: string[];
  @Prop({ required: true })
  private data1!: number[];
  @Prop({ required: true })
  private bgColor1!: string;
  @Prop({ required: true })
  private borderColor1!: string;
  @Prop({ required: true })
  private pointColor1!: string;
  @Prop({ required: true })
  private bgColor2!: string;
  @Prop({ required: true })
  private borderColor2!: string;
  @Prop({ required: true })
  private pointColor2!: string;
  @Prop({ required: true })
  private data2!: number[];

  // グラフ用のデータ
  private chartData: Chart.ChartData = {
    labels: this.chartLabels,
    datasets: [
      {
        // 線の下側をどうするか
        backgroundColor: this.bgColor1,
        borderColor: this.borderColor1,
        pointBackgroundColor: this.pointColor1,
        data: this.data1,
        fill: false,
      },
      {
        // 線の下側をどうするか
        backgroundColor: this.bgColor2,
        borderColor: this.borderColor2,
        pointBackgroundColor: this.pointColor2,
        data: this.data2,
        fill: false,
      },
    ],
  };
  private options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false, fullWidth: false, reverse: false, rtl: false },
    tooltips: { enabled: false },
    plugins: {
      datalabels: {
        // hide datalabels for all datasets
        display: false,
      },
    },
    scales: {
      // 軸設定
      xAxes: [
        // Ｘ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示設定
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0)', // 補助線の色
          },
          ticks: {
            // 目盛り
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
      yAxes: [
        // Ｙ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示の有無
            // フォントサイズ
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0.08)', // 補助線の色
          },
          ticks: {
            // 目盛り
            min: 0, // 最小値
            max: 180, // 最大値
            stepSize: 30, // 軸間隔
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
    },
  };

  public mounted() {
    // グラフを描画
    this.renderChart(this.chartData, this.options);
  }
}
